<template>
<div class="floor-selector">
  <label class="floor-selector-level">
    <input class="floor-selector-input" v-model.number="floor" type="radio" value="3">
    <span class="floor-selector-label">3F</span>
    <svg class="floor-selector-image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.2 19.3" width="54px" height="19px"><path fill="#C2DA92" d="M0,6.7l26.6,6.7l26.6-6.7L26.6,0L0,6.7z"/><path fill="#83A343" d="M53.2,12.7v-6l-26.6,6.7v6L53.2,12.7z"/><path fill="#A4C95B" d="M0,6.7v6l26.6,6.6v-6L0,6.7z"/></svg>
  </label>
  <label class="floor-selector-level">
    <input class="floor-selector-input" v-model.number="floor" type="radio" value="2">
    <span class="floor-selector-label">2F</span>
    <svg class="floor-selector-image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.2 19.3" width="54px" height="19px"><path fill="#C2DA92" d="M0,6.7l26.6,6.7l26.6-6.7L26.6,0L0,6.7z"/><path fill="#83A343" d="M53.2,12.7v-6l-26.6,6.7v6L53.2,12.7z"/><path fill="#A4C95B" d="M0,6.7v6l26.6,6.6v-6L0,6.7z"/></svg>
  </label>
  <label class="floor-selector-level">
    <input class="floor-selector-input" v-model.number="floor" type="radio" value="1">
    <span class="floor-selector-label">1F</span>
    <svg class="floor-selector-image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.2 19.3" width="54px" height="19px"><path fill="#C2DA92" d="M0,6.7l26.6,6.7l26.6-6.7L26.6,0L0,6.7z"/><path fill="#83A343" d="M53.2,12.7v-6l-26.6,6.7v6L53.2,12.7z"/><path fill="#A4C95B" d="M0,6.7v6l26.6,6.6v-6L0,6.7z"/></svg>
  </label>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { app, grid } from '../display'

export default {
  data() {
    return {
    }
  },
  computed: {
    floor: {
      get () {
        return this.$store.state.editor.floor
      },
      set (value) {
        this.updateFloor(value)
      }
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions('editor', ['updateFloor']),
  },
}
</script>

<style lang="scss" scoped>
@import "../../sass/bootstrap";
.floor-selector {
  position: absolute;
  right: 10px;
  bottom: 35px;
}
.floor-selector-level {
  display: flex;
  margin: 0;
  cursor: pointer;
}
.floor-selector-label {
  display: flex;
  align-items: center;
  padding: 0 4px 0 6px;
  width: 44px;
  height: 15px;
  border-radius: 3px;
  @include transition($btn-transition);
  @include button-variant($primary, $primary, #A4CB3F, #A4CB3F, #A4CB3F, #A4CB3F);
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  &:after {
    flex: 0 0 auto;
    content: '';
    display: block;
    margin-left: auto;
    width: 3px;
    height: 5px;
    background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewbox%3D%220%200%203%205%22%20width%3D%223px%22%20height%3D%225px%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M-0%2C-0%20L-0%2C5%20L1%2C5%20L1%2C4%20L2%2C4%20L2%2C3%20L3%2C3%20L3%2C2%20L2%2C2%20L2%2C1%20L1%2C1%20L1%2C-0%20L-0%2C-0%20Z%22%2F%3E%3C%2Fsvg%3E');
  }
}
.floor-selector-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.floor-selector-image {
  margin-left: 10px;
  opacity: 0.5;
}
.floor-selector-input:checked ~ .floor-selector-label {
  background-color: #A4CB3F;
}
.floor-selector-input:checked ~ .floor-selector-image {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// assets/js/components/FloorSelector.vue